import update from 'immutability-helper'
import _ from 'lodash'
import {
    INTEGRATION_LOGS_LIST_FETCHED,
} from '../actions/types'

export default function user(state = {
    list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    model: {

    }
}, action = {}) {
    switch(action.type) {
        case INTEGRATION_LOGS_LIST_FETCHED: 
            return update(state, {
                list: {$set:action.payload}
            })

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/integrations.js